import { render, staticRenderFns } from "./SocTable.vue?vue&type=template&id=093ab562&lang=pug"
import script from "./SocTable.vue?vue&type=script&lang=ts"
export * from "./SocTable.vue?vue&type=script&lang=ts"
import style0 from "./SocTable.vue?vue&type=style&index=0&id=093ab562&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports